import { ProcessDeUtil } from '../../../domain/process-de-util';
import { FormMethodConfig } from './form-method-config';

export class FormFormatConfig {
    constructor() {
        this.id = ProcessDeUtil.createNM();
        this.formMethodConfigs = new Array();
    }
    id: string;
    code: string;
    name: string;
    formFormatId: string;
    description: string;
    formButtonConfigs: Array<FormButtonConfig>;
    formFieldConfigs: Array<FormFieldConfig>;
    formMethodConfigs: Array<FormMethodConfig>;
    formExtendConfigs : string;
}

export class FormButtonConfig {
    buttonId: string;
    buttonState: string;
}

export class FormFieldConfig {
    fieldId: string;
    fieldState: string;
}
